import { optimize } from "@opensea/seadn"
import type { ImageLoaderProps } from "next/image"

export default function seadnLoader({ src, width, quality }: ImageLoaderProps) {
  return optimize(src, { width, quality })
}
